import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 7.333A.667.667 0 0 0 7.333 8v2.667a.667.667 0 1 0 1.334 0V8A.667.667 0 0 0 8 7.333m.253-2.613a.67.67 0 0 0-.506 0 .7.7 0 0 0-.22.14.8.8 0 0 0-.14.22.667.667 0 0 0 .14.727q.097.089.22.14a.667.667 0 0 0 .92-.614.7.7 0 0 0-.194-.473.7.7 0 0 0-.22-.14M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333m0 12A5.333 5.333 0 1 1 8 2.668a5.333 5.333 0 0 1 0 10.665"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })